<template>
    <div>
        <div style="margin-left: 16px">
            <div>
                <input type="file" ref="file" style="display: none" @change="inputChange" accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg">
                <a-button @click="$refs.file.click()">Upload File Tambahan</a-button>
            </div>
            <div v-for="d in data">
                <div style="display: flex; align-items: center; margin-top: 10px">
                    <a :href="baseUrl + '/assets/upload/' + d.file" target="_blank" style="text-decoration: none">
                        <div id="file-tambahan">
                            <a-icon
                                :type="d.file.endsWith('.pdf') ? 'file-pdf' : d.file.endsWith('.doc') || d.file.endsWith('.docx') ? 'file-word' : 'file-image'"
                                :style="'font-size: 34px; color: ' + (d.file.endsWith('.pdf') ? '#d95555' : d.file.endsWith('.doc') || d.file.endsWith('.docx') ? '#4d8adc' : '#6129d0')">
                            </a-icon>
                            <span style="margin-left: 10px; color: #666666;">File Tambahan - {{ d.original_name }}</span>
                        </div>
                    </a>

                    <div id="delete" @click="deleteFile(d.id)">
                        <a-icon type="delete" theme="filled" style="font-size: 22px; color: #e12a2a"></a-icon>
                    </div>
                </div>
            </div>
        </div>
        <iframe id="iframe" :src="embedUrl" frameborder="0"/>
    </div>
</template>

<script>

import {BASE_URL_API} from "../../utils/Config";
import WorkingFormatApi from "../../repository/api/WorkingFormatApi";

export default {
    data() {
        return {
            data: null,
            listener: {},
        }
    },

    async mounted() {
        this.getData()

        const listener = (e) => {
            if (e.data === 'selesai') {
                // this.$router.push({name:'Dashboard'})
                window.location = '/siakri#/dashboards'
                // window.location = '/dashboards'
            }
        };

        window.iFrameResize({ log: false }, '#iframe')
        window.addEventListener("message", listener, false)

        window.addEventListener('scroll', this.onScroll);


        this.listener = listener
    },

    methods: {
        getData() {
            WorkingFormatApi.getAdditional(this.$route.params.id)
                .then((response) => {
                    this.data = response
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        inputChange(e) {
            if (e.target.files.length) {
                const file = e.target.files[0]
                this.$refs.file.value = ''

                if (file.size > 5 * 1024 * 1024) {
                    this.$swal({
                        type: "error",
                        title: "ERROR",
                        icon: 'error',
                        text: "Maksimal file 5 MB",
                    });

                    return
                }

                const reader = new FileReader()

                reader.readAsDataURL(file)
                reader.onload = () => {
                    const result = reader.result

                    this.$swal({
                        title: "Upload",
                        text: "Upload file " + file.name,
                        showCancelButton: true,
                        confirmButtonText: "OK",
                        cancelButtonText: `Batal`,
                        icon: 'question',
                    }).then((res) => {
                        if (res.isConfirmed) {
                            WorkingFormatApi.uploadAdditional(this.$route.params.id, result, file.name)
                                .then((response) => {
                                    this.getData()

                                    this.$swal({
                                        icon: "success",
                                        text: "Upload file tambahan berhasil",
                                    });
                                })
                                .catch((e) => {
                                    this.$swal({
                                        icon: e.severity || "error",
                                        title: (e.severity || "error").toUpperCase(),
                                        text: e.message,
                                    })
                                })
                        }
                    })
                }
                reader.onerror = function (error) {
                    this.$swal({
                        type: "error",
                        title: "ERROR",
                        icon: 'error',
                        text: error,
                    });
                }
            }
        },

        deleteFile(id) {
            this.$swal({
                title: "Hapus",
                text: "Hapus file tambahan?",
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: `Batal`,
                icon: 'question',
            }).then((res) => {
                if (res.isConfirmed) {
                    WorkingFormatApi.deleteAdditional(id)
                        .then((response) => {
                            this.getData()

                            this.$swal({
                                icon: "success",
                                text: "Hapus file tambahan berhasil",
                            });
                        })
                        .catch((e) => {
                            this.$swal({
                                icon: e.severity || "error",
                                title: (e.severity || "error").toUpperCase(),
                                text: e.message,
                            })
                        })
                }
            })
        },

        onScroll(event) {
            var myIframe = document.querySelector('#iframe');
            var topOffset = myIframe.getBoundingClientRect().top + window.scrollY;
            var currentScroll = document.scrollingElement.scrollTop;

            myIframe.contentWindow.postMessage({
                type: 'iframe-pos',
                data: currentScroll
            }, '*');
        },
    },

    computed: {
        embedUrl() {
            return `${BASE_URL_API}/redir/Redir/format_kerja_koas/${this.$route.params.id}/${this.token}`
        },

        token() {
            return this.$store.getters['auth/token']
        },

        baseUrl() {
            return BASE_URL_API
        }
    },

    deactivated() {
        window.removeEventListener("message", this.listener)
        window.removeEventListener("scroll", this.onScroll)
    }
};
</script>

<style lang="scss" scoped>
    #iframe {
        width: 100%;
        overflow: visible;
        min-height: 500px;
    }

    #file-tambahan {
        display: flex;
        align-items: center;
        border: 1px solid #AAAAAA;
        padding: 7px 10px;
        border-radius: 7px;
        background: #FFFFFF;
        transition: all 0.15s;
        cursor: pointer;

        &:hover {
            background: #F4F4F4;
        }
    }

    #delete {
        margin-left: 10px;
        padding: 5px 7px;
        border-radius: 7px;
        background: #FFFFFF;
        transition: all 0.15s;
        cursor: pointer;

        &:hover {
            background: #F4F4F4;
        }
    }
</style>
